import { createActions, createReducer } from 'reduxsauce'

import UnidadeService from '_/servicos/PredioService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaUnidadeInicio: [],
    buscaUnidadeSucesso: ['unidade'],
    buscaUnidadeErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaUnidade = () => {
    return dispatch => {
        dispatch(Creators.buscaUnidadeInicio())
        let serv = new UnidadeService()
        return serv
            .getUnidades()
            .then(response => dispatch(Creators.buscaUnidadeSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaUnidadeErro(error)))
    }
}

const buscaUnidadeInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaUnidadeErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaUnidadeSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.unidade, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_UNIDADE_INICIO]: buscaUnidadeInicio,
    [Types.BUSCA_UNIDADE_ERRO]: buscaUnidadeErro,
    [Types.BUSCA_UNIDADE_SUCESSO]: buscaUnidadeSucesso,
})
